import { bootstrapApplication } from '@angular/platform-browser';
import { enableMapSet } from 'immer';
import { App } from '@app/app';
import { appConfig } from '@core/app.config';
import { environment as Config } from '@env/environment';

// Abilito la gestione delle mappe e dei set in immer
enableMapSet();

// Abilito il log per verificare la versione dell'app
Object.defineProperty(window, 'tagAppWebVersion', {
  value: Config.appVersion,
  writable: false,
  configurable: false
});

bootstrapApplication(App, appConfig).catch((err) => {
  console.error(err);
});
